module.exports = __webpack_public_path__ + "img/sheet.598db638.svg";